var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};

// index.ts
__export(exports, {
  Ast: () => ast_default,
  Tokenizer: () => Tokenizer,
  createElement: () => createElement,
  default: () => master_default,
  expand: () => expand2,
  fromJSON: () => fromJSON,
  functions: () => functions_default,
  nodes: () => schema_default,
  parse: () => parse,
  parseTags: () => parseTags,
  process: () => process,
  render: () => render3,
  renderers: () => renderers_default,
  tags: () => tags_default,
  validate: () => validate2,
  validator: () => validate
});

// src/tokenizer.ts
var import_markdown_it = __toModule(require("markdown-it"));

// src/grammar/tag.ts
function peg$subclass(child, parent) {
  function C() {
    this.constructor = child;
  }
  C.prototype = parent.prototype;
  child.prototype = new C();
}
function peg$SyntaxError(message, expected, found, location) {
  this.message = message;
  this.expected = expected;
  this.found = found;
  this.location = location;
  this.name = "SyntaxError";
  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}
peg$subclass(peg$SyntaxError, Error);
peg$SyntaxError.buildMessage = function(expected, found, location) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function(expectation) {
      return '"' + literalEscape(expectation.text) + '"';
    },
    class: function(expectation) {
      var escapedParts = expectation.parts.map(function(part) {
        return Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part);
      });
      return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
    },
    any: function() {
      return "any character";
    },
    end: function() {
      return "end of input";
    },
    other: function(expectation) {
      return expectation.description;
    },
    not: function(expectation) {
      return "not " + describeExpectation(expectation.expected);
    }
  };
  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }
  function literalEscape(s) {
    return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
      return "\\x0" + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
      return "\\x" + hex(ch);
    });
  }
  function classEscape(s) {
    return s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
      return "\\x0" + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
      return "\\x" + hex(ch);
    });
  }
  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }
  function describeExpected(expected2) {
    var descriptions = expected2.map(describeExpectation);
    var i, j;
    descriptions.sort();
    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }
    switch (descriptions.length) {
      case 1:
        return descriptions[0];
      case 2:
        return descriptions[0] + " or " + descriptions[1];
      default:
        return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
    }
  }
  function describeFound(found2) {
    return found2 ? '"' + literalEscape(found2) + '"' : "end of input";
  }
  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};
function peg$parse(input, options) {
  options = options !== void 0 ? options : {};
  var peg$FAILED = {};
  var peg$startRuleFunctions = { Top: peg$parseTop };
  var peg$startRuleFunction = peg$parseTop;
  var peg$c0 = "/";
  var peg$c1 = ".";
  var peg$c2 = "?";
  var peg$c3 = "#";
  var peg$c4 = "=";
  var peg$c5 = "(";
  var peg$c6 = ")";
  var peg$c7 = ",";
  var peg$c8 = ":";
  var peg$c9 = "[";
  var peg$c10 = "]";
  var peg$c11 = "null";
  var peg$c12 = "true";
  var peg$c13 = "false";
  var peg$c14 = "{";
  var peg$c15 = "}";
  var peg$c16 = '"';
  var peg$c17 = '":';
  var peg$c18 = "-";
  var peg$c19 = "\\";
  var peg$r0 = /^[$@]/;
  var peg$r1 = /^[0-9]/;
  var peg$r2 = /^[0-9.]/;
  var peg$r3 = /^[^\0-\x1F"\\]/;
  var peg$r4 = /^[a-zA-Z0-9_\-]/;
  var peg$r5 = /^[ \n\t]/;
  var peg$e0 = peg$literalExpectation("/", false);
  var peg$e1 = peg$otherExpectation("tag name");
  var peg$e2 = peg$otherExpectation("class");
  var peg$e3 = peg$otherExpectation("id");
  var peg$e4 = peg$literalExpectation("=", false);
  var peg$e5 = peg$literalExpectation("(", false);
  var peg$e6 = peg$literalExpectation(")", false);
  var peg$e7 = peg$literalExpectation(",", false);
  var peg$e8 = peg$otherExpectation("variable");
  var peg$e9 = peg$otherExpectation("null");
  var peg$e10 = peg$otherExpectation("boolean");
  var peg$e11 = peg$literalExpectation("[", false);
  var peg$e12 = peg$literalExpectation("]", false);
  var peg$e13 = peg$literalExpectation("{", false);
  var peg$e14 = peg$literalExpectation("}", false);
  var peg$e15 = peg$literalExpectation('"', false);
  var peg$e16 = peg$literalExpectation('":', false);
  var peg$e17 = peg$literalExpectation(":", false);
  var peg$e18 = peg$otherExpectation("number");
  var peg$e19 = peg$otherExpectation("string");
  var peg$e20 = peg$otherExpectation("identifier");
  var peg$e21 = peg$otherExpectation("whitespace");
  var peg$f0 = function(variable) {
    return { type: "variable", meta: { variable } };
  };
  var peg$f1 = function(attributes) {
    return { type: "annotation", meta: { attributes } };
  };
  var peg$f2 = function(tag, value) {
    return value;
  };
  var peg$f3 = function(tag, primary, attributes, close) {
    if (primary) {
      attributes = attributes || [];
      attributes.unshift({ type: "attribute", name: "primary", value: primary });
    }
    const [type, nesting] = close ? ["tag", 0] : ["tag_open", 1];
    return { type, nesting, meta: { tag, attributes } };
  };
  var peg$f4 = function(tag) {
    return { type: "tag_close", nesting: -1, meta: { tag } };
  };
  var peg$f5 = function(head, tail) {
    return !head ? [] : [head, ...tail];
  };
  var peg$f6 = function(item2) {
    return item2;
  };
  var peg$f7 = function(ids) {
    return ids;
  };
  var peg$f8 = function(classes) {
    return classes;
  };
  var peg$f9 = function(attribute) {
    return attribute;
  };
  var peg$f10 = function(name, variable) {
    return variable;
  };
  var peg$f11 = function(name, condition) {
    let value = condition == null ? true : condition;
    return { type: "class", name, value };
  };
  var peg$f12 = function(value) {
    return { type: "attribute", name: "id", value };
  };
  var peg$f13 = function(name, value) {
    return { type: "attribute", name, value };
  };
  var peg$f14 = function(name, head, tail) {
    return head ? [head, ...tail] : [];
  };
  var peg$f15 = function(name, params) {
    let parameters = {};
    for (let [index, { name: name2, value }] of params.entries())
      parameters[name2 || index] = value;
    return new Function3(name, parameters);
  };
  var peg$f16 = function(name) {
    return name;
  };
  var peg$f17 = function(name, value) {
    return { name, value };
  };
  var peg$f18 = function(value) {
    return value;
  };
  var peg$f19 = function(prefix, namespace) {
    return namespace;
  };
  var peg$f20 = function(prefix, namespace, head, tail) {
    if (prefix === "@")
      return [head, ...tail];
    return new Variable2([head, ...tail], namespace);
  };
  var peg$f21 = function() {
    return null;
  };
  var peg$f22 = function() {
    return true;
  };
  var peg$f23 = function() {
    return false;
  };
  var peg$f24 = function(head, tail) {
    return [head, ...tail];
  };
  var peg$f25 = function(value) {
    return value || [];
  };
  var peg$f26 = function(head, tail) {
    return Object.assign(head, ...tail);
  };
  var peg$f27 = function(value) {
    return value || {};
  };
  var peg$f28 = function(key) {
    return key;
  };
  var peg$f29 = function(key, value) {
    return { [key]: value };
  };
  var peg$f30 = function() {
    return parseFloat(text2());
  };
  var peg$f31 = function(value) {
    return value.join("");
  };
  var peg$f32 = function(sequence) {
    return sequence;
  };
  var peg$currPos = 0;
  var peg$savedPos = 0;
  var peg$posDetailsCache = [{ line: 1, column: 1 }];
  var peg$expected = [];
  var peg$silentFails = 0;
  var peg$result;
  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error(`Can't start parsing from rule "` + options.startRule + '".');
    }
    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }
  function text2() {
    return input.substring(peg$savedPos, peg$currPos);
  }
  function offset() {
    return peg$savedPos;
  }
  function range() {
    return [peg$savedPos, peg$currPos];
  }
  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }
  function expected(description, location2) {
    location2 = location2 !== void 0 ? location2 : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildStructuredError([peg$otherExpectation(description)], input.substring(peg$savedPos, peg$currPos), location2);
  }
  function error2(message, location2) {
    location2 = location2 !== void 0 ? location2 : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildSimpleError(message, location2);
  }
  function peg$literalExpectation(text3, ignoreCase) {
    return { type: "literal", text: text3, ignoreCase };
  }
  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts, inverted, ignoreCase };
  }
  function peg$anyExpectation() {
    return { type: "any" };
  }
  function peg$endExpectation() {
    return { type: "end" };
  }
  function peg$otherExpectation(description) {
    return { type: "other", description };
  }
  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos];
    var p;
    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }
      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };
      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }
        p++;
      }
      peg$posDetailsCache[pos] = details;
      return details;
    }
  }
  var peg$VALIDFILENAME = typeof options.filename === "string" && options.filename.length > 0;
  function peg$computeLocation(startPos, endPos) {
    var loc = {};
    if (peg$VALIDFILENAME)
      loc.filename = options.filename;
    var startPosDetails = peg$computePosDetails(startPos);
    loc.start = {
      offset: startPos,
      line: startPosDetails.line,
      column: startPosDetails.column
    };
    var endPosDetails = peg$computePosDetails(endPos);
    loc.end = {
      offset: endPos,
      line: endPosDetails.line,
      column: endPosDetails.column
    };
    return loc;
  }
  function peg$begin() {
    peg$expected.push({ pos: peg$currPos, variants: [] });
  }
  function peg$expect(expected2) {
    var top = peg$expected[peg$expected.length - 1];
    if (peg$currPos < top.pos) {
      return;
    }
    if (peg$currPos > top.pos) {
      top.pos = peg$currPos;
      top.variants = [];
    }
    top.variants.push(expected2);
  }
  function peg$end(invert) {
    var expected2 = peg$expected.pop();
    var top = peg$expected[peg$expected.length - 1];
    var variants = expected2.variants;
    if (top.pos !== expected2.pos) {
      return;
    }
    if (invert) {
      variants = variants.map(function(e) {
        return e.type === "not" ? e.expected : { type: "not", expected: e };
      });
    }
    Array.prototype.push.apply(top.variants, variants);
  }
  function peg$buildSimpleError(message, location2) {
    return new peg$SyntaxError(message, null, null, location2);
  }
  function peg$buildStructuredError(expected2, found, location2) {
    return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected2, found, location2), expected2, found, location2);
  }
  function peg$buildError() {
    var expected2 = peg$expected[0];
    var failPos = expected2.pos;
    return peg$buildStructuredError(expected2.variants, failPos < input.length ? input.charAt(failPos) : null, failPos < input.length ? peg$computeLocation(failPos, failPos + 1) : peg$computeLocation(failPos, failPos));
  }
  function peg$parseTop() {
    var s0;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$parseTopLevelValue();
    if (s0 === peg$FAILED) {
      s0 = peg$parseAnnotation();
      if (s0 === peg$FAILED) {
        s0 = peg$parseTagOpen();
        if (s0 === peg$FAILED) {
          s0 = peg$parseTagClose();
        }
      }
    }
    return s0;
  }
  function peg$parseTopLevelValue() {
    var s0, s1;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = peg$parseVariable();
    if (s1 === peg$FAILED) {
      s1 = peg$parseFunction();
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f0(s1);
    }
    s0 = s1;
    return s0;
  }
  function peg$parseAnnotation() {
    var s0, s1, s2, s3;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = peg$parseTagAttributes();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parse_();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parse_();
      }
      peg$savedPos = s0;
      s0 = peg$f1(s1);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseTagOpen() {
    var s0, s1, s2, s3, s4, s5, s6;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = peg$parseTagName();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parse_();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parse_();
      }
      s3 = peg$currPos;
      s4 = peg$parseValue();
      if (s4 !== peg$FAILED) {
        s5 = peg$parse_();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        peg$savedPos = s3;
        s3 = peg$f2(s1, s4);
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parseTagAttributes();
      if (s4 === peg$FAILED) {
        s4 = null;
      }
      s5 = [];
      s6 = peg$parse_();
      while (s6 !== peg$FAILED) {
        s5.push(s6);
        s6 = peg$parse_();
      }
      rule$expects(peg$e0);
      if (input.charCodeAt(peg$currPos) === 47) {
        s6 = peg$c0;
        peg$currPos++;
      } else {
        s6 = peg$FAILED;
      }
      if (s6 === peg$FAILED) {
        s6 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f3(s1, s3, s4, s6);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseTagClose() {
    var s0, s1, s2;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    rule$expects(peg$e0);
    if (input.charCodeAt(peg$currPos) === 47) {
      s1 = peg$c0;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseTagName();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f4(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseTagName() {
    var s0;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    rule$expects(peg$e1);
    peg$silentFails++;
    s0 = peg$parseIdentifier();
    peg$silentFails--;
    return s0;
  }
  function peg$parseTagAttributes() {
    var s0, s1, s2, s3;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = peg$parseTagAttributesItem();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseTagAttributesTail();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseTagAttributesTail();
      }
      peg$savedPos = s0;
      s0 = peg$f5(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseTagAttributesTail() {
    var s0, s1, s2;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parse_();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parse_();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseTagAttributesItem();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f6(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseTagAttributesItem() {
    var s0, s1;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = peg$parseTagShortcutId();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f7(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseTagShortcutClass();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f8(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseTagAttribute();
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f9(s1);
        }
        s0 = s1;
      }
    }
    return s0;
  }
  function peg$parseTagShortcutClass() {
    var s0, s1, s2, s3, s4, s5;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    rule$expects(peg$e2);
    peg$silentFails++;
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 46) {
      s1 = peg$c1;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseIdentifier();
      if (s2 !== peg$FAILED) {
        s3 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 63) {
          s4 = peg$c2;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseVariable();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s3;
            s3 = peg$f10(s2, s5);
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        if (s3 === peg$FAILED) {
          s3 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f11(s2, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$silentFails--;
    return s0;
  }
  function peg$parseTagShortcutId() {
    var s0, s1, s2;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    rule$expects(peg$e3);
    peg$silentFails++;
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 35) {
      s1 = peg$c3;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseIdentifier();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f12(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$silentFails--;
    return s0;
  }
  function peg$parseTagAttribute() {
    var s0, s1, s2, s3;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = peg$parseIdentifier();
    if (s1 !== peg$FAILED) {
      rule$expects(peg$e4);
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c4;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseValue();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f13(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseFunction() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = peg$parseIdentifier();
    if (s1 !== peg$FAILED) {
      rule$expects(peg$e5);
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c5;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parse_();
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parse_();
        }
        s4 = peg$currPos;
        s5 = peg$parseFunctionParameter();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        s6 = [];
        s7 = peg$parseFunctionParameterTail();
        while (s7 !== peg$FAILED) {
          s6.push(s7);
          s7 = peg$parseFunctionParameterTail();
        }
        peg$savedPos = s4;
        s4 = peg$f14(s1, s5, s6);
        rule$expects(peg$e6);
        if (input.charCodeAt(peg$currPos) === 41) {
          s5 = peg$c6;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
        }
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f15(s1, s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseFunctionParameter() {
    var s0, s1, s2, s3;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parseIdentifier();
    if (s2 !== peg$FAILED) {
      rule$expects(peg$e4);
      if (input.charCodeAt(peg$currPos) === 61) {
        s3 = peg$c4;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s1;
        s1 = peg$f16(s2);
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parseValue();
    if (s2 !== peg$FAILED) {
      peg$savedPos = s0;
      s0 = peg$f17(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseFunctionParameterTail() {
    var s0, s1, s2, s3, s4;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parse_();
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parse_();
    }
    rule$expects(peg$e7);
    if (input.charCodeAt(peg$currPos) === 44) {
      s2 = peg$c7;
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      s3 = [];
      s4 = peg$parse_();
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        s4 = peg$parse_();
      }
      s4 = peg$parseFunctionParameter();
      if (s4 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f18(s4);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseVariable() {
    var s0, s1, s2, s3, s4, s5;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    rule$expects(peg$e8);
    peg$silentFails++;
    s0 = peg$currPos;
    if (peg$r0.test(input.charAt(peg$currPos))) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      s3 = peg$parseIdentifier();
      if (s3 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 58) {
          s4 = peg$c8;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          peg$savedPos = s2;
          s2 = peg$f19(s1, s3);
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      s3 = peg$parseIdentifier();
      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$parseVariableTail();
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$parseVariableTail();
        }
        peg$savedPos = s0;
        s0 = peg$f20(s1, s2, s3, s4);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$silentFails--;
    return s0;
  }
  function peg$parseVariableTail() {
    var s0, s1, s2, s3;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 46) {
      s1 = peg$c1;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseIdentifier();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f16(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 91) {
        s1 = peg$c9;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parseValueNumber();
        if (s2 === peg$FAILED) {
          s2 = peg$parseValueString();
        }
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 93) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f18(s2);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    return s0;
  }
  function peg$parseValue() {
    var s0;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$parseValueNull();
    if (s0 === peg$FAILED) {
      s0 = peg$parseValueBoolean();
      if (s0 === peg$FAILED) {
        s0 = peg$parseValueString();
        if (s0 === peg$FAILED) {
          s0 = peg$parseValueNumber();
          if (s0 === peg$FAILED) {
            s0 = peg$parseValueArray();
            if (s0 === peg$FAILED) {
              s0 = peg$parseValueHash();
              if (s0 === peg$FAILED) {
                s0 = peg$parseFunction();
                if (s0 === peg$FAILED) {
                  s0 = peg$parseVariable();
                }
              }
            }
          }
        }
      }
    }
    return s0;
  }
  function peg$parseValueNull() {
    var s0, s1;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    rule$expects(peg$e9);
    peg$silentFails++;
    s0 = peg$currPos;
    if (input.substr(peg$currPos, 4) === peg$c11) {
      s1 = peg$c11;
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f21();
    }
    s0 = s1;
    peg$silentFails--;
    return s0;
  }
  function peg$parseValueBoolean() {
    var s0, s1;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    rule$expects(peg$e10);
    peg$silentFails++;
    s0 = peg$currPos;
    if (input.substr(peg$currPos, 4) === peg$c12) {
      s1 = peg$c12;
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f22();
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 5) === peg$c13) {
        s1 = peg$c13;
        peg$currPos += 5;
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f23();
      }
      s0 = s1;
    }
    peg$silentFails--;
    return s0;
  }
  function peg$parseValueArray() {
    var s0, s1, s2, s3, s4, s5, s6;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    rule$expects(peg$e11);
    if (input.charCodeAt(peg$currPos) === 91) {
      s1 = peg$c9;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parse_();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parse_();
      }
      s3 = peg$currPos;
      s4 = peg$parseValueArrayItem();
      if (s4 !== peg$FAILED) {
        s5 = [];
        s6 = peg$parseValueArrayTail();
        while (s6 !== peg$FAILED) {
          s5.push(s6);
          s6 = peg$parseValueArrayTail();
        }
        peg$savedPos = s3;
        s3 = peg$f24(s4, s5);
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      rule$expects(peg$e7);
      if (input.charCodeAt(peg$currPos) === 44) {
        s4 = peg$c7;
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
      }
      if (s4 === peg$FAILED) {
        s4 = null;
      }
      s5 = [];
      s6 = peg$parse_();
      while (s6 !== peg$FAILED) {
        s5.push(s6);
        s6 = peg$parse_();
      }
      rule$expects(peg$e12);
      if (input.charCodeAt(peg$currPos) === 93) {
        s6 = peg$c10;
        peg$currPos++;
      } else {
        s6 = peg$FAILED;
      }
      if (s6 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f25(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseValueArrayTail() {
    var s0, s1, s2, s3, s4;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parse_();
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parse_();
    }
    rule$expects(peg$e7);
    if (input.charCodeAt(peg$currPos) === 44) {
      s2 = peg$c7;
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      s3 = [];
      s4 = peg$parse_();
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        s4 = peg$parse_();
      }
      s4 = peg$parseValueArrayItem();
      if (s4 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f18(s4);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseValueArrayItem() {
    var s0, s1;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = peg$parseValue();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f18(s1);
    }
    s0 = s1;
    return s0;
  }
  function peg$parseValueHash() {
    var s0, s1, s2, s3, s4, s5, s6;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    rule$expects(peg$e13);
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c14;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parse_();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parse_();
      }
      s3 = peg$currPos;
      s4 = peg$parseValueHashItem();
      if (s4 !== peg$FAILED) {
        s5 = [];
        s6 = peg$parseValueHashTail();
        while (s6 !== peg$FAILED) {
          s5.push(s6);
          s6 = peg$parseValueHashTail();
        }
        peg$savedPos = s3;
        s3 = peg$f26(s4, s5);
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = [];
      s5 = peg$parse_();
      while (s5 !== peg$FAILED) {
        s4.push(s5);
        s5 = peg$parse_();
      }
      rule$expects(peg$e14);
      if (input.charCodeAt(peg$currPos) === 125) {
        s5 = peg$c15;
        peg$currPos++;
      } else {
        s5 = peg$FAILED;
      }
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f27(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseValueHashTail() {
    var s0, s1, s2, s3, s4;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parse_();
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parse_();
    }
    rule$expects(peg$e7);
    if (input.charCodeAt(peg$currPos) === 44) {
      s2 = peg$c7;
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      s3 = [];
      s4 = peg$parse_();
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        s4 = peg$parse_();
      }
      s4 = peg$parseValueHashItem();
      if (s4 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f6(s4);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseValueHashItem() {
    var s0, s1, s2, s3, s4;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    s1 = peg$currPos;
    rule$expects(peg$e15);
    if (input.charCodeAt(peg$currPos) === 34) {
      s2 = peg$c16;
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      s3 = peg$parseIdentifier();
      if (s3 !== peg$FAILED) {
        rule$expects(peg$e16);
        if (input.substr(peg$currPos, 2) === peg$c17) {
          s4 = peg$c17;
          peg$currPos += 2;
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          peg$savedPos = s1;
          s1 = peg$f28(s3);
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 === peg$FAILED) {
      s1 = peg$currPos;
      s2 = peg$parseIdentifier();
      if (s2 !== peg$FAILED) {
        rule$expects(peg$e17);
        if (input.charCodeAt(peg$currPos) === 58) {
          s3 = peg$c8;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s1;
          s1 = peg$f28(s2);
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parse_();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parse_();
      }
      s3 = peg$parseValue();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f29(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseValueNumber() {
    var s0, s1, s2, s3, s4;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    rule$expects(peg$e18);
    peg$silentFails++;
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 45) {
      s1 = peg$c18;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    if (peg$r1.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      s3 = [];
      if (peg$r2.test(input.charAt(peg$currPos))) {
        s4 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
      }
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        if (peg$r2.test(input.charAt(peg$currPos))) {
          s4 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f30();
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$silentFails--;
    return s0;
  }
  function peg$parseValueString() {
    var s0, s1, s2, s3;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    rule$expects(peg$e19);
    peg$silentFails++;
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 34) {
      s1 = peg$c16;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseValueStringChars();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseValueStringChars();
      }
      if (input.charCodeAt(peg$currPos) === 34) {
        s3 = peg$c16;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f31(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$silentFails--;
    return s0;
  }
  function peg$parseValueStringChars() {
    var s0;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    if (peg$r3.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseValueStringEscapes();
    }
    return s0;
  }
  function peg$parseValueStringEscapes() {
    var s0, s1, s2;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 92) {
      s1 = peg$c19;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 34) {
        s2 = peg$c16;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
      }
      if (s2 === peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 92) {
          s2 = peg$c19;
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
        }
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f32(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    return s0;
  }
  function peg$parseIdentifier() {
    var s0, s1, s2;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    rule$expects(peg$e20);
    peg$silentFails++;
    s0 = peg$currPos;
    s1 = [];
    if (peg$r4.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        if (peg$r4.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }
    peg$silentFails--;
    return s0;
  }
  function peg$parse_() {
    var s0;
    var rule$expects = function(expected2) {
      if (peg$silentFails === 0)
        peg$expect(expected2);
    };
    rule$expects(peg$e21);
    peg$silentFails++;
    if (peg$r5.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
    }
    peg$silentFails--;
    return s0;
  }
  const { Variable: Variable2, Function: Function3 } = options;
  peg$begin();
  peg$result = peg$startRuleFunction();
  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$expect(peg$endExpectation());
    }
    throw peg$buildError();
  }
}

// src/ast/base.ts
var Base = class {
  get astType() {
    return "base";
  }
  toJSON() {
    return { $$mdtype: this.astType, ...this };
  }
  resolve(config) {
    return this;
  }
  expand(config) {
    return null;
  }
  expandValue(value, config) {
    if (Base.isAst(value))
      return value.expand(config);
    if (Array.isArray(value))
      return {
        type: "array",
        value: value.map((item2) => this.expandValue(item2, config))
      };
    if (value == null || typeof value !== "object")
      return value;
    return {
      type: "hash",
      value: Object.entries(value).map(([name, value2]) => ({
        type: "attribute",
        name,
        value: this.expandValue(value2, config)
      }))
    };
  }
  static isAst(value) {
    return value && value.astType;
  }
  static resolve(value, config) {
    return this.isAst(value) ? value.resolve(config) : value;
  }
  static expand(value, config) {
    return this.isAst(value) ? value.expand(config) : value;
  }
};

// src/ast/variable.ts
var Variable = class extends Base {
  constructor(path = [], namespace, defaultValue) {
    super();
    this.path = path;
    this.namespace = namespace;
    this.default = defaultValue;
  }
  get astType() {
    return "Variable";
  }
  expand(config) {
    if (this.namespace === "state")
      return { type: "variable", path: this.path, default: this.default };
    const resolved = this.resolve(config);
    return this.expandValue(resolved);
  }
  resolve({ variables }) {
    if (this.namespace === "state")
      return this;
    const value = variables instanceof Function ? variables(this.namespace, this.path) : this.path.reduce((obj = {}, key) => obj[key], variables);
    return value === void 0 ? this.default : value;
  }
  toText() {
    const varParts = [`$`];
    if (this.namespace) {
      varParts.push(`${this.namespace}:`);
    }
    varParts.push(...this.path.map((pathPart, idx) => {
      if (isIdentifier(pathPart)) {
        if (idx > 0) {
          varParts.push(`.`);
        }
        varParts.push(pathPart);
      } else {
        varParts.push(`[${JSON.stringify(pathPart)}]`);
      }
    }));
    return varParts.join(``);
  }
};

// src/ast/function.ts
var Function2 = class extends Base {
  constructor(name, parameters) {
    super();
    this.name = name;
    this.parameters = parameters;
  }
  get astType() {
    return "Function";
  }
  expand(config) {
    return this.resolve(config);
  }
  resolve(config = {}) {
    let fn = config.functions[this.name];
    if (!fn)
      return;
    let value = fn.render(this.parameters, config);
    return Base.resolve(value, config);
  }
  toText() {
    var paramStr = Object.entries(this.parameters).map(([key, val]) => (isIdentifier(key) ? `${key}=` : ``) + attrValueToText(val)).join(", ");
    return `${this.name}(${paramStr})`;
  }
};

// src/utils.ts
var STATES = {
  normal: 0,
  string: 1,
  escape: 2
};
function findTagEnd(content, start = 0, open = "{%", close = "%}") {
  let state = STATES.normal;
  let stack = 0;
  for (let pos = start; pos < content.length; pos++) {
    let char = content[pos];
    switch (state) {
      case STATES.string:
        switch (char) {
          case '"':
            state = STATES.normal;
            break;
          case "\\":
            state = STATES.escape;
            break;
        }
        break;
      case STATES.escape:
        state = STATES.string;
        break;
      case STATES.normal:
        if (char === '"')
          state = STATES.string;
        else if (content.startsWith(open, pos))
          stack++;
        else if (content.startsWith(close, pos)) {
          stack--;
          if (stack == 0)
            return pos;
        }
    }
  }
}
function parseTag(content, line, contentStart) {
  try {
    return peg$parse(content, { Variable, Function: Function2 });
  } catch (error2) {
    if (!(error2 instanceof peg$SyntaxError))
      throw error2;
    const { message, location: { start, end } } = error2;
    const location = {
      start: { line, character: start.offset + contentStart },
      end: { line: line + 1, character: end.offset + contentStart }
    };
    return { type: "error", meta: { error: { message, location } } };
  }
}
function parseTags(content, firstLine, open = "{%", close = "%}") {
  let line = firstLine + 1;
  let output = [];
  let start = 0;
  for (let pos = 0; pos < content.length; pos++) {
    if (content[pos] === "\n") {
      line++;
      continue;
    }
    if (!content.startsWith(open, pos))
      continue;
    let end = findTagEnd(content, pos, open, close);
    let text2 = content.slice(pos, end + close.length);
    let inner = content.slice(pos + open.length, end);
    let lineStart = content.lastIndexOf("\n", pos);
    let lineEnd = content.indexOf("\n", end);
    let lineContent = content.slice(lineStart, lineEnd);
    let tag = parseTag(inner.trim(), line, pos - lineStart);
    let precedingTextEnd = lineContent.trim() === text2 ? lineStart : pos;
    let precedingText = content.slice(start, precedingTextEnd);
    output.push({
      type: "text",
      start,
      end: pos - 1,
      content: precedingText
    });
    output.push({
      map: [line, line + 1],
      position: {
        start: pos - lineStart,
        end: pos - lineStart + text2.length
      },
      start: pos,
      end: pos + text2.length - 1,
      info: text2,
      ...tag
    });
    start = end + close.length;
    pos = start - 1;
  }
  output.push({
    type: "text",
    start,
    end: content.length - 1,
    content: content.slice(start)
  });
  return output;
}
function isIdentifier(str) {
  return /^[a-zA-Z][a-zA-Z0-9_-]*$/.test(str);
}
function attrValueToText(attrVal) {
  const attrValType = typeof attrVal;
  if (/^string|number|bigint|boolean|undefined$/.test(attrValType) || attrValType === null) {
    return JSON.stringify(attrVal);
  } else if (attrValType === "object") {
    if (attrVal.toText instanceof Function2) {
      return attrVal.toText();
    } else if (Array.isArray(attrVal)) {
      return `[${attrVal.map(attrValueToText).join(`, `)}]`;
    } else {
      return `{${Object.entries(attrVal).map(([key, val]) => `${isIdentifier(key) ? key : JSON.stringify(key)}: ${attrValueToText(val)}`).join(`, `)}}`;
    }
  } else {
    throw new Error(`Can't convert type:${attrValType} to text for ${attrVal}`);
  }
}
function attributesToText(attributes, ignoredAttrNames = null) {
  const ignoredAttrNamesSet = new Set(ignoredAttrNames || []);
  return Object.entries(attributes).filter(([attrName, _]) => !ignoredAttrNamesSet.has(attrName)).map(([attrName, attrVal]) => {
    const attrTextVal = attrValueToText(attrVal);
    if (attrName === "primary") {
      return attrTextVal;
    } else if (attrName === "id") {
      return `#${attrVal}`;
    } else if (attrName === "class") {
      return Object.entries(attrVal).map(([className, classVal]) => {
        if (classVal === true) {
          return `.${className}`;
        } else if (classVal instanceof Variable) {
          return `.${className}?${classVal.toText()}`;
        }
      }).join(` `);
    } else {
      return `${attrName}=${attrTextVal}`;
    }
  }).join(` `);
}
function toAnnotationsText(attributes, ignoredAttributes = null) {
  let attrsText = attributesToText(attributes, ignoredAttributes);
  if (attrsText) {
    attrsText = `{% ${attrsText} %}`;
  }
  return attrsText;
}
function getIndentation(markdocAttributes) {
  const indentation = " ".repeat(markdocAttributes.indentation);
  return indentation ? [indentation] : [];
}

// src/plugins/annotations.ts
function createToken(state, content, contentStart) {
  try {
    const { type, meta, nesting = 0 } = peg$parse(content, { Variable, Function: Function2 });
    const token = state.push(type, null, nesting);
    token.info = content;
    token.meta = meta;
    if (!state.delimiters)
      state.delimiters = [];
    return token;
  } catch (error2) {
    if (!(error2 instanceof peg$SyntaxError))
      throw error2;
    const { message, location: { start, end } } = error2;
    const location = contentStart ? {
      start: { offset: start.offset + contentStart },
      end: { offset: end.offset + contentStart }
    } : null;
    const token = state.push("error", null, 0);
    token.meta = { error: { message, location } };
    return token;
  }
}
function block(state, startLine, endLine, silent) {
  const { open, close } = state.env.markdoc;
  let start = state.bMarks[startLine] + state.tShift[startLine];
  let finish = state.eMarks[startLine];
  if (!state.src.startsWith(open, start))
    return false;
  let tagEnd = findTagEnd(state.src, start, open, close);
  let lastPossible = state.src.slice(0, finish).trim().length;
  if (!tagEnd || tagEnd < lastPossible - close.length)
    return false;
  let contentStart = start + open.length;
  let content = state.src.slice(contentStart, tagEnd).trim();
  let lines = content.split("\n").length;
  if (content[0] === "$")
    return false;
  if (silent)
    return true;
  let token = createToken(state, content, contentStart);
  token.map = [startLine, startLine + lines];
  state.line += lines;
  return true;
}
function inline(state, silent) {
  const { open, close } = state.env.markdoc;
  if (!state.src.startsWith(open, state.pos))
    return false;
  const tagEnd = findTagEnd(state.src, state.pos, open, close);
  if (!tagEnd)
    return false;
  const content = state.src.slice(state.pos + open.length, tagEnd);
  if (!silent)
    createToken(state, content.trim());
  state.pos = tagEnd + close.length;
  return true;
}
function core(state) {
  const { open, close } = state.env.markdoc;
  for (let token of state.tokens) {
    if (token.type !== "fence")
      continue;
    if (token.info.includes(open)) {
      let start = token.info.indexOf(open);
      let end = findTagEnd(token.info, start, open, close);
      let content = token.info.slice(start + open.length, end);
      try {
        let { meta } = peg$parse(content.trim(), { Variable, Function: Function2 });
        token.meta = meta;
      } catch (error2) {
        if (!(error2 instanceof peg$SyntaxError))
          throw error2;
        if (!token.errors)
          token.errors = [];
        token.errors.push({
          id: "fence-tag-error",
          level: "error",
          message: `Syntax error in fence tag: ${error2.message}`
        });
      }
    }
    if (token.meta && token.meta.attributes && token.meta.attributes.find((attr) => attr.name === "process" && !attr.value))
      continue;
    token.children = parseTags(token.content, token.map[0]);
  }
}
function plugin(md, options) {
  md.block.ruler.before("paragraph", "annotations", block, { alt: ["", "paragraph"] });
  md.inline.ruler.push("containers", inline);
  md.core.ruler.push("annotations", core);
}

// src/plugins/frontmatter.ts
var fence = "---";
function getLine(state, n) {
  return state.src.slice(state.bMarks[n], state.eMarks[n]).trim();
}
function findClose(state, endLine) {
  for (let line = 1; line < endLine; line++)
    if (getLine(state, line) === fence)
      return line;
}
function block2(state, startLine, endLine, silent) {
  if (startLine != 0 || getLine(state, 0) != fence)
    return false;
  const close = findClose(state, endLine);
  if (!close)
    return false;
  if (silent)
    return true;
  const token = state.push("frontmatter", null, 0);
  token.content = state.src.slice(state.eMarks[0], state.bMarks[close]).trim();
  token.map = [0, close];
  token.hidden = true;
  state.line = close + 1;
  return true;
}
function plugin2(md, options) {
  md.block.ruler.before("hr", "frontmatter", block2);
}

// src/tokenizer.ts
var Tokenizer = class {
  constructor(config) {
    this.parser = (0, import_markdown_it.default)(config);
    this.parser.use(plugin, "annotations", {});
    this.parser.use(plugin2, "frontmatter", {});
    this.parser.disable(["code", "lheading"]);
  }
  tokenize(content, { open = "{%", close = "%}" } = {}) {
    const env = { markdoc: { open, close } };
    return this.parser.parse(content.toString(), env);
  }
};

// src/ast/tag.ts
var Tag = class extends Base {
  constructor(name, attributes = {}, children = [], inline3) {
    super();
    this.name = name;
    this.attributes = attributes;
    this.children = children;
    this.inline = inline3;
  }
  get astType() {
    return "Tag";
  }
  expandAttrs(value, config) {
    return Base.isAst(value) ? value.expand(config) : this.expandValue(value, config);
  }
  expand(config = {}) {
    let children = this.children.flatMap((child) => Base.expand(child, config));
    let attributes = Object.entries(this.attributes).map(([name, value]) => ({
      name,
      type: name === "class" ? "class" : "attribute",
      value: this.expandAttrs(value, config)
    }));
    return {
      type: "tag",
      name: this.name,
      inline: this.inline,
      children,
      attributes
    };
  }
};

// src/ast/node.ts
var globalAttributes = {
  class: { render: true },
  id: { type: String, render: true }
};
var Node = class {
  constructor(type = "node", attributes = {}, children = []) {
    this.attributes = attributes;
    this.children = children;
    this.errors = [];
    this.lines = [];
    this.type = type;
    this.markdocAttributes = {};
  }
  get tag() {
    return this.type.split(":")[1];
  }
  *walk() {
    for (let child of this.children) {
      yield child;
      yield* child.walk();
    }
  }
  push(node) {
    this.children.push(node);
  }
  toJSON() {
    return { $$mdtype: "Node", ...this };
  }
  detectConsecutiveListNodes() {
    let consecutiveOrderedLists = 0;
    let consecutiveUnorderedLists = 0;
    this.children.forEach((child) => {
      if (child.type == "list") {
        const markerPriority = child.attributes.ordered ? ++consecutiveOrderedLists : ++consecutiveUnorderedLists;
        child.markdocAttributes.itemMarkerPriority = markerPriority - 1;
      } else {
        consecutiveOrderedLists = 0;
        consecutiveUnorderedLists = 0;
      }
    });
  }
  toText(config) {
    if (this.tag) {
      let attrsStr = attributesToText(this.attributes);
      if (attrsStr) {
        attrsStr = ` ${attrsStr}`;
      }
      let innerText = this.children.flatMap((child) => {
        const childTextParts = child.toText(config);
        if (!this.inline && !child.inline) {
          childTextParts.push("\n");
        }
        return childTextParts;
      }).join("");
      const isInline = this.inline && !innerText.includes("\n");
      if (!isInline) {
        innerText = innerText.trim();
      }
      if (innerText) {
        const openTag = `{% ${this.tag}${attrsStr} %}`;
        const closeTag = `{% /${this.tag} %}`;
        if (isInline) {
          return [openTag, innerText, closeTag];
        } else {
          return [openTag, "\n", innerText, "\n", closeTag];
        }
      } else {
        return [`{% ${this.tag}${attrsStr} /%}`];
      }
    }
    this.detectConsecutiveListNodes();
    const schema = config.nodes[this.type];
    if (schema && schema.toText instanceof Function)
      return schema.toText(this, config);
    if (!this.children.length)
      return [];
    return this.children.flatMap((child) => child.toText(config));
  }
  findSchema({ nodes = {}, tags = {} } = {}) {
    return this.tag ? tags[this.tag] : nodes[this.type];
  }
  resolve(value, config = {}) {
    if (Base.isAst(value))
      return value.resolve ? value.resolve(config) : value;
    if (Array.isArray(value))
      return value.map((item2) => this.resolve(item2, config));
    if (value == null || typeof value !== "object")
      return value;
    const output = {};
    for (let [k, v] of Object.entries(value))
      output[k] = this.resolve(v, config);
    return output;
  }
  renderAttributes(attributes = {}) {
    let output = {};
    const attrs = { ...globalAttributes, ...attributes };
    for (let [key, attr] of Object.entries(attrs)) {
      if (attr.render == false)
        continue;
      let name = typeof attr.render === "string" ? attr.render : key;
      let value = this.attributes[key] === void 0 ? attr.default : this.attributes[key];
      if (value === void 0)
        continue;
      output[name] = value;
    }
    return output;
  }
  renderChildren(config) {
    return this.children.flatMap((child) => child.render(config));
  }
  renderNode(config) {
    const schema = this.findSchema(config);
    if (schema && schema.render instanceof Function)
      return schema.render(this, config);
    const children = this.renderChildren(config);
    if (!schema || !schema.tag)
      return children;
    const name = schema.tag instanceof Function ? schema.tag(this) : schema.tag;
    const attributes = this.renderAttributes(schema.attributes);
    return new Tag(name, attributes, children, this.inline);
  }
  render(config = {}) {
    return config.debug ? config.debug(this, config) : this.renderNode(config);
  }
};

// src/ast/boolean.ts
var Not = class extends Base {
  constructor(value) {
    super();
    this.value = value;
  }
  get astType() {
    return "Not";
  }
  expand(config) {
    const value = this.resolve(config);
    return Base.isAst(value) ? { type: "not", value: this.value.expand(config) } : value;
  }
  resolve(config) {
    const value = Base.resolve(this.value, config);
    return Base.isAst(value) ? new Not(value) : !value;
  }
};
var Boolean2 = class extends Base {
  constructor(operator, values) {
    super();
    this.operator = operator;
    this.values = values;
  }
  get astType() {
    return "Boolean";
  }
  expand(config) {
    let value = this.resolve(config);
    if (!Base.isAst(value))
      return value;
    let type = this.operator === Boolean2.And ? "and" : "or";
    return { type, value: this.values.map((item2) => Base.expand(item2, config)) };
  }
  resolve(config) {
    let output = [];
    for (let item2 of this.values) {
      let value = Base.resolve(item2, config);
      if (Base.isAst(value)) {
        output.push(value);
        continue;
      }
      if (this.operator === Boolean2.And && !value)
        return false;
      if (this.operator === Boolean2.Or && value)
        return true;
    }
    if (output.length > 1)
      return new Boolean2(this.operator, output);
    if (output.length == 1)
      return output[0];
    return this.operator === Boolean2.And;
  }
};
Boolean2.And = Symbol("And");
Boolean2.Or = Symbol("Or");

// src/ast/conditional.ts
var Conditional = class extends Base {
  constructor(value, isTrue, isFalse) {
    super();
    this.value = value;
    this.true = isTrue;
    this.false = isFalse;
  }
  get astType() {
    return "Conditional";
  }
  expandChildren(value, config) {
    if (Array.isArray(value))
      return value.map((child) => Base.expand(child, config));
    return Base.expand(value, config);
  }
  expand(config = {}) {
    let value = Base.resolve(this.value, config);
    let trueChildren = this.expandChildren(this.true, config);
    let falseChildren = this.expandChildren(this.false, config);
    if (Base.isAst(value))
      return {
        type: "conditional",
        true: trueChildren,
        false: falseChildren,
        value: Base.expand(value, config)
      };
    return value ? trueChildren : falseChildren;
  }
  resolve(config = {}) {
    let value = Base.resolve(this.value, config);
    if (Base.isAst(value))
      return new Conditional(value, this.true, this.false);
    return value ? this.true : this.false;
  }
};

// src/ast/scope.ts
var Scope = class extends Base {
  constructor(variables = {}, children = []) {
    super();
    this.variables = variables;
    this.children = children;
  }
  get astType() {
    return "Scope";
  }
  expand(config) {
    const children = this.children.flatMap((child) => Base.expand(child, { ...config, variables: this.variables }));
    return { type: "fragment", children };
  }
};

// src/ast/index.ts
var { isAst, resolve, expand } = Base;
var ast_default = {
  isAst,
  resolve,
  expand,
  Base,
  Boolean: Boolean2,
  Conditional,
  Node,
  Function: Function2,
  Tag,
  Scope,
  Variable
};

// src/transforms/table.ts
function convertToRow(node, cellType = "td") {
  node.type = "tr";
  node.attributes = {};
  for (let cell of node.children)
    cell.type = cellType;
  return node;
}
function transform(document2) {
  for (let node of document2.walk()) {
    if (node.type !== "tag:table")
      continue;
    const [first, ...rest] = node.children;
    if (!first || first.type === "table")
      continue;
    const table3 = new ast_default.Node("table", node.attributes, [
      new ast_default.Node("thead"),
      new ast_default.Node("tbody")
    ]);
    const [thead2, tbody2] = table3.children;
    if (first.type === "list")
      thead2.push(convertToRow(first, "th"));
    for (let row of rest) {
      if (row.type === "list")
        convertToRow(row);
      else if (row.type === "tag:if") {
        const children = [];
        for (let child of row.children) {
          if (child.type === "hr")
            continue;
          if (child.type === "list")
            convertToRow(child);
          children.push(child);
        }
        row.children = children;
      } else
        continue;
      tbody2.push(row);
    }
    node.children = [table3];
  }
}

// src/transforms/index.ts
var transforms_default = [transform];

// src/parser.ts
var mappings = {
  ordered_list: "list",
  bullet_list: "list",
  code_inline: "code",
  list_item: "item",
  variable: "text"
};
function annotate(node, attributes) {
  for (let { name, value, type } of attributes)
    if (type === "attribute")
      node.attributes[name] = value;
    else if (type === "class")
      if (node.attributes.class)
        node.attributes.class[name] = value;
      else
        node.attributes.class = { [name]: value };
}
function handleAttrs(token, type) {
  switch (type) {
    case "heading":
      return { level: Number(token.tag.replace("h", "")) };
    case "list":
      return { ordered: token.type.startsWith("ordered") };
    case "link":
    case "image":
      return Object.fromEntries(token.attrs);
    case "text":
    case "code":
      return { content: (token.meta || {}).variable || token.content };
    case "fence":
      return {
        content: token.content,
        language: token.info.split(" ", 1)[0]
      };
    default:
      return {};
  }
}
function handleToken(token, nodes, file, inlineParent) {
  if (token.type === "frontmatter") {
    nodes[0].attributes.frontmatter = token.content;
    return;
  }
  if (token.hidden)
    return;
  if (token.type === "softbreak") {
    token.type = "text";
    token.content = " ";
  }
  const errors = token.errors || [];
  const parent = nodes[nodes.length - 1];
  const { tag, attributes, error: error2 } = token.meta || {};
  if (token.type === "annotation") {
    if (inlineParent)
      return annotate(inlineParent, attributes);
    return lastNode.errors.push({
      id: "no-inline-annotations",
      level: "error",
      message: `Can't apply inline annotations to '${parent.type}'`
    });
  }
  let typeName = token.type.replace(/_(open|close)$/, "");
  if (mappings[typeName])
    typeName = mappings[typeName];
  if (tag)
    typeName = `tag:${tag}`;
  if (typeName === "error") {
    const { message, location } = error2;
    errors.push({ id: "parse-error", level: "critical", message, location });
  }
  if (token.nesting < 0) {
    if (parent.type === typeName) {
      if (parent.lines && token.map)
        parent.lines.push(...token.map);
      return nodes.pop();
    }
    errors.push({
      id: "missing-opening",
      level: "critical",
      message: `Node '${typeName}' is missing opening`
    });
  }
  const attrs = handleAttrs(token, typeName);
  const node = new Node(typeName, attrs);
  const { position = {} } = token;
  node.errors = errors;
  node.lines = token.map || parent.lines || [];
  node.location = {
    file,
    start: {
      line: node.lines[0],
      character: position.start
    },
    end: {
      line: node.lines[1],
      character: position.end
    }
  };
  if (inlineParent)
    node.inline = true;
  if (attributes && (["fence", "image"].includes(typeName) || typeName.startsWith("tag:")))
    annotate(node, attributes);
  parent.push(node);
  if (token.nesting > 0)
    nodes.push(node);
  if (!Array.isArray(token.children))
    return;
  inlineParent = parent;
  nodes.push(node);
  for (let child of token.children)
    handleToken(child, nodes, file, inlineParent);
  nodes.pop();
}
function parser(tokens, file) {
  let doc = new Node("document");
  let nodes = [doc];
  for (let token of tokens)
    handleToken(token, nodes, file);
  if (nodes.length > 1)
    for (let node of nodes.slice(1))
      node.errors.push({
        id: "missing-closing",
        level: "critical",
        message: `Node '${node.tag || node.type}' is missing closing`
      });
  for (let transform2 of transforms_default)
    transform2(doc);
  return doc;
}

// src/schema.ts
var document = {
  children: [
    "heading",
    "paragraph",
    "image",
    "table",
    "tag",
    "fence",
    "blockquote",
    "list",
    "hr"
  ],
  attributes: {
    frontmatter: { render: false }
  },
  toText(node, config) {
    let frontmatter = node.attributes.frontmatter;
    if (frontmatter === void 0) {
      frontmatter = "";
    } else if (frontmatter === "") {
      frontmatter = "---\n---\n";
    } else {
      frontmatter = `---
${frontmatter}
---
`;
    }
    let childrenText = node.children.flatMap((child) => [...child.toText(config), "\n\n"]);
    return [frontmatter, ...childrenText];
  }
};
var heading = {
  children: ["inline"],
  attributes: {
    level: { type: Number, render: false, required: true }
  },
  toText(node, config) {
    const children = node.children.flatMap((child) => child.toText(config));
    const hashes = "#".repeat(node.attributes.level || 1);
    return [hashes, " ", ...children, toAnnotationsText(node.attributes, Object.keys(this.attributes))];
  },
  tag(node) {
    return `h${node.attributes["level"]}`;
  }
};
var paragraph = {
  tag: "p",
  children: ["inline"]
};
var image = {
  tag: "img",
  attributes: {
    src: { type: String, required: true }
  },
  toText(node, config) {
    const altText = node.children.flatMap((child) => child.toText(config));
    return ["![", altText, "](", node.attributes.src, ")"];
  }
};
var fence2 = {
  tag: "pre",
  localize: false,
  attributes: {
    content: { type: String, render: false, required: true },
    language: { type: String, render: "data-language" },
    process: { type: Boolean, render: false, default: true }
  },
  render(node, config) {
    const attrs = node.renderAttributes(this.attributes);
    const children = node.children.length ? node.renderChildren(config) : [node.attributes.content];
    return new Tag(this.tag, attrs, children);
  },
  toText(node, config) {
    const children = node.children.flatMap((child) => {
      child.markdocAttributes.indentation = node.markdocAttributes.indentation;
      return child.toText(config);
    });
    var longestMarker = 0;
    for (let val of children) {
      for (let line of val.split("\n")) {
        var numBackticks = line.search(/[^`]/) < 0 ? line.length : 0;
        longestMarker = Math.max(longestMarker, numBackticks);
      }
    }
    ;
    var numFenceChars = Math.max(3, longestMarker + 1);
    var codeMarker = "`".repeat(numFenceChars);
    const language = node.attributes.language ? node.attributes.language : "";
    const annotation = toAnnotationsText(node.attributes, Object.keys(this.attributes));
    const indentation = getIndentation(node.markdocAttributes);
    return [
      ...indentation,
      `${codeMarker}${language}`,
      annotation ? ` ${annotation}` : ``,
      `
`,
      ...children,
      codeMarker
    ];
  }
};
var blockquote = {
  tag: "blockquote",
  children: [
    "heading",
    "paragraph",
    "image",
    "table",
    "tag",
    "fence",
    "blockquote",
    "list",
    "hr"
  ],
  toText(node, config) {
    const children = node.children.flatMap((child) => child.toText(config));
    var bqStr = ">";
    if (!children || children[0][0] != bqStr) {
      bqStr += " ";
    }
    return [bqStr, ...children];
  }
};
var item = {
  tag: "li",
  children: [
    "inline",
    "heading",
    "paragraph",
    "image",
    "table",
    "tag",
    "fence",
    "blockquote",
    "list",
    "hr"
  ],
  toText(node, config) {
    let marker = node.markdocAttributes.itemMarker;
    let firstChild = true;
    return node.children.flatMap((child) => {
      if (child.type == "list") {
        firstChild = false;
        child.markdocAttributes.indentation = node.markdocAttributes.indentation + 4;
        return child.toText(config);
      } else if (firstChild) {
        firstChild = false;
        child.markdocAttributes.indentation = node.markdocAttributes.indentation + marker.length;
        let indentation = getIndentation(node.markdocAttributes);
        if (child.type == "table" || child.type == "fence")
          marker = marker + "\n";
        return [...indentation, marker, ...child.toText(config), toAnnotationsText(node.attributes), "\n"];
      } else {
        child.markdocAttributes.indentation = node.markdocAttributes.indentation + marker.length;
        return [...child.toText(config), toAnnotationsText(node.attributes), "\n"];
      }
    });
  }
};
var list = {
  children: ["item"],
  attributes: {
    ordered: { type: Boolean, render: false, required: true }
  },
  tag(node) {
    return node.attributes.ordered ? "ol" : "ul";
  },
  unorderedDelimeters: ["- ", "+ ", "* "],
  orderedDelimeters: ["1. ", "1) "],
  toText(node, config) {
    return node.children.flatMap((child) => {
      const priority = node.markdocAttributes.itemMarkerPriority % 2;
      child.markdocAttributes.itemMarker = node.attributes.ordered ? this.orderedDelimeters[priority] : this.unorderedDelimeters[priority];
      child.markdocAttributes.indentation = node.markdocAttributes.indentation ? node.markdocAttributes.indentation : 0;
      return child.toText(config);
    });
  }
};
var hr = {
  tag: "hr",
  toText(node, config) {
    return ["---"];
  }
};
var table = {
  tag: "table",
  toText(node, config) {
    const children = node.children.flatMap((child) => child.toText(config));
    return [...children];
  }
};
function tableDataToText(node, config) {
  const children = [];
  const indent = "  ";
  for (let child of node.children) {
    if (child.inline || child.type === "inline") {
      children.push(...child.toText(config));
    } else {
      let text2 = child.toText(config).join("").split("\n").map((line) => indent + line).join("\n");
      children.push("\n" + text2);
    }
  }
  ;
  return ["* ", ...children, toAnnotationsText(node.attributes), "\n"];
}
var td = {
  tag: "td",
  children: [
    "inline",
    "heading",
    "paragraph",
    "image",
    "table",
    "tag",
    "fence",
    "blockquote",
    "list",
    "hr"
  ],
  attributes: {
    colspan: { type: Number },
    rowspan: { type: Number },
    align: { type: String }
  },
  toText(node, config) {
    return tableDataToText(node, config);
  }
};
var th = {
  tag: "th",
  attributes: {
    width: { type: Number },
    align: { type: String }
  },
  toText(node, config) {
    return tableDataToText(node, config);
  }
};
var tr = {
  tag: "tr",
  children: ["th", "td"],
  toText(node, config) {
    const children = node.children.flatMap((child) => child.toText(config));
    return [...children];
  }
};
var tbody = {
  tag: "tbody",
  children: ["tr", "tag"],
  toText(node, config) {
    const children = node.children.flatMap((child) => ["---\n", ...child.toText(config)]);
    return [...children];
  }
};
var thead = {
  tag: "thead",
  children: ["tr"],
  toText(node, config) {
    const children = node.children.flatMap((child) => child.toText(config));
    return [...children];
  }
};
var strong = {
  tag: "strong",
  children: [
    "em",
    "link",
    "code",
    "text",
    "tag"
  ],
  toText(node, config) {
    const children = node.children.flatMap((child) => child.toText(config));
    return ["**", ...children, "**"];
  }
};
var em = {
  tag: "em",
  children: [
    "strong",
    "link",
    "code",
    "text",
    "tag"
  ],
  toText(node, config) {
    const children = node.children.flatMap((child) => child.toText(config));
    return ["*", ...children, "*"];
  }
};
var inline2 = {
  children: [
    "strong",
    "em",
    "code",
    "text",
    "tag",
    "link"
  ]
};
var link = {
  tag: "a",
  children: [
    "strong",
    "em",
    "code",
    "text",
    "tag"
  ],
  attributes: {
    href: { type: String, required: true },
    title: { type: String }
  },
  toText(node, config) {
    const children = node.children.flatMap((child) => child.toText(config));
    const title = node.attributes.title ? [' "', node.attributes.title.replace('"', '\\"'), '"'] : [];
    return [
      "[",
      ...children,
      "]",
      "(",
      node.attributes.href,
      ...title,
      ")"
    ];
  }
};
var code = {
  tag: "code",
  attributes: {
    content: { type: String, render: false, required: true }
  },
  toText(node, config) {
    return ["`", node.attributes.content, "`"];
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes);
    return new Tag(this.tag, attributes, [node.attributes.content]);
  }
};
var text = {
  attributes: {
    content: { type: String, required: true }
  },
  toText(node, config) {
    const content = node.attributes.content;
    const indentation = getIndentation(node.markdocAttributes);
    if (content instanceof Variable) {
      return indentation + `{% ${content.toText()} %}`;
    } else {
      return indentation + content.replace(/\n/g, "\n" + indentation);
    }
  },
  render(node, config) {
    return node.attributes.content;
  }
};
var error = {};
var schema_default = {
  document,
  heading,
  paragraph,
  hr,
  image,
  fence: fence2,
  blockquote,
  list,
  item,
  table,
  thead,
  tbody,
  tr,
  td,
  th,
  inline: inline2,
  strong,
  em,
  link,
  code,
  text,
  error
};

// src/tags/conditional.ts
var tagIf = {
  attributes: {
    primary: { type: Object, render: false }
  },
  conditions(node) {
    const conditions = [{ condition: node.attributes.primary, children: [] }];
    for (let child of node.children) {
      if (child.type === "tag:else")
        conditions.push({ condition: child.attributes.primary, children: [] });
      else
        conditions[conditions.length - 1].children.push(child);
    }
    return conditions;
  },
  render(node, config) {
    const conditions = this.conditions(node);
    const output = [];
    for (let { condition = true, children } of conditions) {
      let value = ast_default.resolve(condition, config);
      if (!value)
        continue;
      children = children.flatMap((child) => child.render(config));
      if (ast_default.isAst(value)) {
        output.unshift({ value, children });
        continue;
      }
      if (output.length < 1)
        return children;
      output.unshift({ value, children });
      break;
    }
    if (output.length < 1)
      return [];
    return output.reduce((acc, { value, children }) => new ast_default.Conditional(value, children, acc), null);
  }
};
var tagElse = {
  selfClosing: true,
  attributes: {
    primary: { type: Object, render: false }
  }
};

// src/tags/partial.ts
var partial = {
  selfClosing: true,
  attributes: {
    file: { type: String, render: false, required: true },
    variables: { type: Object, render: false }
  },
  render(node, config) {
    const { partials = {} } = config;
    const { file, variables } = node.attributes;
    const partial2 = partials[file];
    if (!partial2)
      return;
    const resolved = node.resolve(variables, config);
    const children = partial2.renderChildren({
      ...config,
      variables: {
        ...config.variables,
        ...resolved,
        ["$$partial:filename"]: file
      }
    });
    return new ast_default.Scope(resolved, children);
  }
};

// src/tags/table.ts
var table2 = {
  children: ["table"]
};

// src/tags/index.ts
var tags_default = {
  if: tagIf,
  else: tagElse,
  partial,
  table: table2
};

// src/functions/index.ts
var and = {
  render(parameters, config) {
    return new Boolean2(Boolean2.And, Object.values(parameters));
  }
};
var or = {
  render(parameters, config) {
    return new Boolean2(Boolean2.Or, Object.values(parameters));
  }
};
var not = {
  render(parameters, config) {
    return new Not(parameters[0]);
  }
};
var equals = {
  render(parameters, config) {
    const values = Object.values(parameters).map((v) => ast_default.resolve(v, config));
    return values.every((v) => v === values[0]);
  }
};
var functions_default = { and, or, not, equals };

// src/renderers/html.ts
var import_markdown_it2 = __toModule(require("markdown-it"));
var { escapeHtml } = (0, import_markdown_it2.default)().utils;
function generateClass(hash) {
  const classes = [];
  for (let { name, value } of hash)
    if (value)
      classes.push(name);
  return classes.join(" ");
}
function render(node) {
  if (["string", "number"].includes(typeof node))
    return escapeHtml(String(node));
  if (Array.isArray(node))
    return node.map(render);
  if (!node || !node.type)
    return "";
  const { type, name, value } = node;
  switch (type) {
    case "attribute":
      return ` ${name}="${escapeHtml(String(value))}"`;
    case "class":
      const classname = generateClass(value.value);
      return classname ? ` ${name}="${classname}"` : "";
    case "variable":
      return node.default ? render(node.default) : "";
    case "fragment":
      return render(node.children).join("");
    case "tag":
      const { inline: inline3, attributes = [], children = [] } = node;
      const output = ["<", name, ...render(attributes), ">"];
      if (children.length)
        output.push(...render(children), "</", name, ">");
      if (!inline3)
        output.push("\n\n");
      return output.join("");
    default:
      return "";
  }
}

// src/renderers/react.ts
function generateClass2(hash) {
  const classes = [];
  for (let [k, v] of Object.entries(hash))
    if (v)
      classes.push(k);
  return classes.join(" ");
}
function resolveVariable(variables, path = [], defaultValue) {
  const value = variables instanceof Function ? variables(path) : path.reduce((obj = {}, key) => obj[key], variables);
  return value === void 0 ? defaultValue : value;
}
function tagName(name, components) {
  return typeof name !== "string" ? "Fragment" : name[0] !== name[0].toUpperCase() ? name : components instanceof Function ? components(name) : components[name];
}
function dynamic(node, React) {
  return ({ variables = {}, components = {} } = {}) => {
    function render4(node2) {
      if (Array.isArray(node2))
        return node2.map(render4);
      if (node2 == null || typeof node2 !== "object")
        return node2;
      const { type, name, value } = node2;
      switch (type) {
        case "array":
          return render4(value);
        case "hash":
          return render4(value).reduce((out, cur) => ({ ...out, ...cur }), {});
        case "attribute":
          return { [String(name)]: render4(value) };
        case "class":
          return { className: generateClass2(render4(value)) };
        case "variable":
          return resolveVariable(variables, node2.path, node2.default);
        case "and":
          return value.every((variable) => render4(variable));
        case "or":
          return value.find((variable) => render4(variable));
        case "not":
          return !render4(value);
        case "conditional":
          return render4(value) ? render4(node2.true) : render4(node2.false);
        case "fragment":
          return React.createElement(React.Fragment, null, ...render4(node2.children));
        case "tag":
          const { attributes = [], children = [] } = node2;
          const attrs = attributes.length ? render4({ type: "hash", value: attributes }) : null;
          return React.createElement(tagName(name, components), attrs, ...render4(children));
      }
    }
    return render4(node);
  };
}
function render2(node) {
  if (Array.isArray(node))
    return node.map(render2);
  if (node == null || typeof node !== "object")
    return JSON.stringify(node);
  const { type, name, value } = node;
  switch (type) {
    case "array":
      return `[${render2(value)}]`;
    case "hash":
      return `{${render2(value)}}`;
    case "attribute":
      return `${JSON.stringify(name)}: ${render2(value)}`;
    case "class":
      return `className: generateClass(${render2(value)})`;
    case "and":
      return `(${render2(value).join(" && ")})`;
    case "or":
      return `(${render2(value).join(" || ")})`;
    case "not":
      return `(!(${render2(value)}))`;
    case "variable":
      const path = JSON.stringify(node.path || []);
      const def = JSON.stringify(node.default);
      return `resolveVariable(variables, ${path}, ${def})`;
    case "conditional":
      return `${render2(value)} ? [${render2(node.true)}] : [${render2(node.false)}]`;
    case "fragment":
      return `
React.createElement(React.Fragment, null, ${render2(node.children)})`;
    case "tag":
      const { attributes = [], children = [] } = node;
      const attrs = attributes.length ? `{${render2(attributes)}}` : null;
      const tag = `tagName(${JSON.stringify(name)}, components)`;
      return `
React.createElement(${tag}, ${attrs}, ${render2(children)})`;
  }
}
var codeTemplate = (code2) => `
(({variables = {}, components = {}} = {}) => {
  ${generateClass2}
  ${resolveVariable}
  ${tagName}
  return ${code2.trim()};
})
`;
function react_default(node, React) {
  if (React && React.createElement)
    return dynamic(node, React);
  return codeTemplate(render2(node));
}

// src/renderers/index.ts
var renderers_default = { html: render, react: react_default };

// src/validator.ts
var TypeMappings = {
  String,
  Number,
  Array,
  Object,
  Boolean
};
function validateType(type, value) {
  if (!type || ast_default.isAst(value))
    return true;
  if (Array.isArray(type))
    return type.some((t) => validateType(t, value));
  if (typeof type === "string")
    type = TypeMappings[type];
  return value.constructor === type;
}
function typeToString(type) {
  if (typeof type === "string")
    return type;
  if (Array.isArray(type))
    return type.map(typeToString).join(" | ");
  return type.name;
}
function validate(node, config) {
  const schema = node.findSchema(config);
  const errors = [...node.errors || []];
  if (!schema) {
    errors.push({
      id: node.tag ? "tag-undefined" : "node-undefined",
      level: "critical",
      message: node.tag ? `Undefined tag '${node.tag}'` : `Undefined node '${node.type}'`
    });
    return errors;
  }
  if (schema.selfClosing && node.children.length > 0)
    errors.push({
      id: "tag-selfclosing-has-children",
      level: "critical",
      message: `Tag '${node.tag}' should be self-closing`
    });
  const attributes = {
    ...globalAttributes,
    ...schema.attributes
  };
  if (schema.validate)
    errors.push(...schema.validate(node, config));
  for (let [key, value] of Object.entries(node.attributes)) {
    let attrib = attributes[key];
    if (!attrib) {
      errors.push({
        id: "attribute-undefined",
        level: "error",
        message: `Invalid attribute '${key}'`
      });
      continue;
    }
    if (ast_default.isAst(value))
      continue;
    if (key === "id" && value.match(/^[0-9]/))
      errors.push({
        id: "attribute-value-invalid",
        level: "error",
        message: "The ID attribute must not start with a number"
      });
    let { type, matches, errorLevel } = attrib;
    if (!validateType(type, value))
      errors.push({
        id: "attribute-type-invalid",
        level: errorLevel || "error",
        message: `Attribute '${key}' must be type '${typeToString(type)}'`
      });
    if (typeof matches === "function")
      matches = matches(config);
    if (Array.isArray(matches) && !matches.includes(value))
      errors.push({
        id: "attribute-value-invalid",
        level: errorLevel || "error",
        message: `Attribute '${key}' must match one of ${JSON.stringify(matches)}`
      });
    if (matches instanceof RegExp && !matches.test(value))
      errors.push({
        id: "attribute-value-invalid",
        level: errorLevel || "error",
        message: `Attribute '${key}' must match ${matches}`
      });
  }
  for (let [key, { required }] of Object.entries(attributes))
    if (required && node.attributes[key] === void 0)
      errors.push({
        id: "attribute-missing-required",
        level: "error",
        message: `Missing required attribute '${key}'`
      });
  for (let { type } of node.children)
    if (schema.children && type !== "error" && !schema.children.includes(type.split(":")[0]))
      errors.push({
        id: "child-invalid",
        level: "warning",
        message: `Can't nest '${type}' in '${node.tag || node.type}'`
      });
  return errors;
}

// index.ts
var tokenizer = new Tokenizer();
function reviver(key, value) {
  if (!value)
    return value;
  const klass = ast_default[value.$$mdtype];
  return klass ? Object.assign(new klass(), value) : value;
}
function mergeConfig(config = {}) {
  return {
    ...config,
    tags: {
      ...tags_default,
      ...config.tags
    },
    nodes: {
      ...schema_default,
      ...config.nodes
    },
    functions: {
      ...functions_default,
      ...config.functions
    }
  };
}
function parse(content, file, delimiters) {
  if (typeof content === "string")
    content = tokenizer.tokenize(content, delimiters);
  return parser(content, file);
}
function process(content, config) {
  config = mergeConfig(config);
  if (typeof content === "string")
    content = parse(content);
  if (Array.isArray(content))
    return content.flatMap((child) => child.render(config));
  return content.render(config);
}
function expand2(content, config) {
  config = mergeConfig(config);
  if (typeof content === "string")
    content = process(content, config);
  if (Array.isArray(content))
    return {
      type: "fragment",
      children: content.flatMap((child) => ast_default.expand(child, config))
    };
  return ast_default.expand(content, config);
}
function render3(content, config, renderer = "html", ...args) {
  config = mergeConfig(config);
  if (typeof content === "string")
    content = expand2(content, config);
  if (content instanceof Node) {
    const processed = process(content, config);
    content = expand2(processed, config);
  }
  return renderers_default[renderer](content, ...args);
}
function fromJSON(text2) {
  return JSON.parse(text2, reviver);
}
function validate2(content, config) {
  config = mergeConfig(config);
  if (typeof content === "string")
    content = parse(content);
  const output = [];
  for (let node of [content, ...content.walk()]) {
    let { type, lines, location } = node;
    let errors = validate(node, config);
    for (let error2 of errors)
      output.push({ type, lines, location, error: error2 });
  }
  return output;
}
function createElement(name, attributes = {}, ...children) {
  return { name, attributes, children };
}
var master_default = {
  nodes: schema_default,
  tags: tags_default,
  functions: functions_default,
  renderers: renderers_default,
  Ast: ast_default,
  Tokenizer,
  parseTags,
  validator: validate,
  parse,
  process,
  expand: expand2,
  render: render3,
  fromJSON,
  validate: validate2,
  createElement
};
